import type { ProjectEndDto } from '@nsb/core';
import { dateWords } from '../../days.ts';

/** The day a project ended: "April 18, 2026". */
export function endedDay(ended: ProjectEndDto): string {
  return dateWords(ended.at, 'long');
}

/** "on April 18, 2026, by the client" */
export function endedWords(ended: ProjectEndDto): string {
  return `on ${endedDay(ended)}, by ${ended.by === 'client' ? 'the client' : 'NSB'}`;
}
